import React, { useState, useRef, useEffect, useContext } from "react";
import { baseUrl } from '../../config.js'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

import Buscador from '../Buscador/Buscador.js';
import Login from '../Login/Login.js';
import Modal from "../Modal/Modal.js";

import './NavBar.css';
import Burger from '../../img/Burger.png';
import Perfil from '../../img/Perfil.png';
import Logo from '../../img/logoV2.png';
import LogoMobile from '../../img/logo.png';
import Filtros from '../../img/Filtros.png';
import Buscar from '../../img/Buscar.png';
import Flecha from '../../img/Flecha.png';

import useToken from "../../useToken.js";
import { BuscadorContext } from "../Buscador/BuscadorContext.js";
// Si la url guardada del avatar esta rota (hubo avatares que quedaron con el
// index.html dentro), el navegador pintaba el alt. Caemos a la imagen local y
// desmarcamos el flag para no volver a intentar en bucle.
const alFallarFoto = (e) => {
  if (e.currentTarget.dataset.fallback) return;
  e.currentTarget.dataset.fallback = '1';
  e.currentTarget.src = Perfil;
  e.currentTarget.classList.remove('conImg');
};


const NavBar = ({user, setUser, modalLogin, setModalLogin, modalFiltro, setModalFiltro, tourMenuAbierto, setModalAyuda, tourActivo})=>{
    const {token, setToken} = useToken();
    const [showNavbar, setShowNavbar] = useState(true);
    const {filtros, setFiltros, totalFavs, setTotalFavs} = useContext(BuscadorContext);
    const [totalFiltros, setTotalFiltros] = useState(0);
    const [modalBuscador, setModalBuscador] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    // Cerrar sesion dejaba al usuario en la pagina donde estaba, que podia ser
    // una ruta privada ya sin sesion. Se limpia el estado, se cierra en Cognito
    // y se vuelve al inicio.
    const auth = useAuth();

    const cerrarSesion = async () => {
        setUser({});
        setToken('');
        try {
            // Cierra tambien en Keycloak, no solo en la app: si solo se
            // borrara la sesion local, volver a entrar no pediria credenciales
            // porque el proveedor seguiria teniendo la suya abierta.
            await auth.signoutRedirect();
        } catch (error) {
            console.log('signOut', error);
        }
        navigate('/');
    };
    const [menu, setMenu] = useState(false);
    const [focused, setFocused] = useState(false);
    const [mas, setMas] = useState(false);
    const [mobileMenu, setMobileMenu] = useState(false);
    const [gestionOpen, setGestionOpen] = useState(false);

    const menuNav = useRef(null);
    const masNav = useRef(null);

    useEffect(()=>{
        document.querySelector(".nav")?.classList?.add("min");
        window.scroll({top:0})
    },[location])

    useEffect(() => {
        setMenu(false);
        setMobileMenu(false);
        if (location.pathname.split("/")[1] == "host") {
            setShowNavbar(false);
        }
        else {
          setShowNavbar(true);
        }
        // Abrir automáticamente el sub-menú si la ruta activa es de gestión
        if (location.pathname.startsWith('/host/gestion')) {
            setGestionOpen(true);
        }
    }, [location]);

    useEffect(()=>{
        setTotalFavs(user?.favs || 0);
    }, [user])

    useEffect(()=>{
        if(tourMenuAbierto > 0) {
            if (window.innerWidth <= 767) {
                setMobileMenu(true);
            } else {
                setMenu(true);
            }
        }
    }, [tourMenuAbierto])

    useEffect(()=>{
        if(focused)
            document.querySelector(".nav").classList.add("focused");
        else
            document.querySelector(".nav").classList.remove("focused");
        return ()=>{
            document.querySelector(".nav").classList.remove("focused");
        }
    }, [focused])

    useEffect(()=>{
        if(menu || mas)
            document.body.onclick = handleMenu;
        else
            document.body.onclick = undefined;
    }, [menu, mas])

    useEffect(()=>{
        const total = (filtros?.services?.length + filtros?.types?.length) || 0;
        setTotalFiltros(total);
        setModalBuscador(false);
    },[filtros])

    const handleMenu = (e)=>{
        if(menuNav.current && !menuNav.current.contains(e.target))
            setMenu(false);
        if(masNav.current && !masNav.current.contains(e.target))
            setMas(false);
    }
    const eliminarDatos = ()=>{
        if(window.confirm("Esto eliminará al usuario y todos sus datos, ¿estás seguro?")){
            fetch(baseUrl+"eliminarUsuario", {
                headers:{
                    'Authorization': `Bearer ${token}`,
                }
            })
            .then(response=>response.json())
            .then(json=>{
                cerrarSesion();
            })
        }
    }
    if(showNavbar)
        return(
            <>
                {modalLogin &&
                
                    <Modal className='divLogin' setModal={setModalLogin}>
                        <Login setModalLogin={setModalLogin} user={user} setUser={setUser}/>
                    </Modal>
                }
                <nav className={"nav min"}>
                    <nav className="navbar">
                        <Link to='/' className="logo" tabIndex={-1} onClick={(e)=>{
                            if(!e.ctrlKey && !e.shiftKey)
                                setFiltros({})
                        }}>
                            <img src={Logo}/>
                            <img src={LogoMobile} className="logoMobile"/>
                        </Link>
                        <span className="navDerecha">
                            {user?.Acepterms &&
                                <Link to="/host" tabIndex={-1}>Modo Anfitrión</Link>
                            }
                            {!user?.Acepterms &&
                                <Link to="/unirte" tabIndex={-1}>Renta tu almacén</Link>
                            }
                            {!tourActivo && setModalAyuda &&
                                <button className="nav-ayuda" onClick={()=> setModalAyuda(true)} title="Centro de ayuda" aria-label="Abrir centro de ayuda">?</button>
                            }
                            <span className="menu" data-tour="nav-menu" onClick={(e)=>{
                                e.stopPropagation();
                                setMenu(!menu);
                            }}>
                                <img src={Burger} className="burger" alt="Menú"/>
                                <img src={user.url ? user.url : user.picture ? user.picture : Perfil} className={"imgPerfil"+(user.url || user.picture ? " conImg" : "")} alt="Menú Perfil" onError={alFallarFoto}/>
                                {user?.notifications?.client > 0 &&
                                    <div className='numNoti'>
                                        {user.notifications?.client > 99 ? "99+" : user.notifications?.client}
                                    </div>
                                }
                            </span>
                            {menu && !user.sub &&
                                <div className="menuNav" ref={menuNav}>
                                    <button data-tour="btn-registrate" onClick={()=>{
                                        setModalLogin(true)
                                    }}>
                                        <b>Regístrate</b></button>
                                    <button onClick={()=>{
                                        setModalLogin(true)
                                    }}>Iniciar sesión</button>
                                </div>
                            }
                            {menu && user.sub &&
                                <div className="menuNav" ref={menuNav}>
                                    <div className="bold">
                                        <Link to="/dashboard">Dashboard</Link>
                                        <Link to="/mensajes">Mensajes</Link>
                                        <Link to="/notificaciones">Mis Notificaciones {(user.notifications?.client != 0 ? `(${user.notifications?.client})` : '')}</Link>
                                        <Link to="/host/gestion/publicaciones">Mis Publicaciones {(user.posts ? `(${user.posts})` : '')}</Link>
                                        <Link to="/reservaciones">Mis Reservaciones {(user.bookings ? `(${user.bookings})` : '')}</Link>
                                        <Link to="/mi-stock">Mi Stock</Link>
                                        <Link to="/mis-productos">Mis Productos</Link>
                                        <Link to="/favoritos">Mis Favoritos{totalFavs != 0 ? " ("+totalFavs+")" : ""}</Link>
                                    </div>
                                    <div>
                                        <Link data-tour="btn-renta" to="/host">Renta tu almacén</Link>
                                        <Link to="/perfil">Mi Perfil</Link>
                                        <Link to="#" onClick={eliminarDatos}>Eliminar datos (test only)</Link>
                                        <Link to="/transferencia">Simular Transferencia (test only)</Link>
                                    </div>
                                    <div>
                                        <Link to="/ayuda">Ayuda</Link>
                                        <button onClick={cerrarSesion}>Cerrar sesión</button>
                                    </div>
                                </div>
                            }
                        </span>
                    </nav>
                    <Buscador focused={focused} setFocused={setFocused}/>
                </nav>
                {location.pathname !== '/perfil' &&
                <nav className="fakeSearch">
                    <div className="buscador" onClick={()=>{
                        setModalBuscador(true);
                    }}>
                        <div>
                            <span className="iconoBuscar">
                                <img src={Buscar}/>
                            </span>
                            <span className="label">
                                <div>Busca tu almacén ideal</div>
                                <div>Lugar | Fecha | Espacios</div>
                            </span>
                        </div>
                    </div>
                    <div className="filtros">
                        <button 
                            className={totalFiltros ? "conFiltros" : ""}
                            onClick={()=>{
                                setModalFiltro(true);
                            }}>
                            {totalFiltros!==0 &&
                                <div className="totalFiltros">{totalFiltros}</div>
                            }
                            <img src={Filtros}/>
                            <span>Filtros</span>
                        </button>
                    </div>
                </nav>
                }
                {modalBuscador &&
                    <Buscador modal={true} setModalBuscador={setModalBuscador}/>
                }

                {/* Top navbar móvil — cliente, solo mobile */}
                <nav className="navHostMobile">
                    <Link to='/' className="logo" tabIndex={-1} onClick={(e)=>{ if(!e.ctrlKey && !e.shiftKey) setFiltros({}) }}>
                        <img src={Logo}/>
                        <img src={LogoMobile} className="logoMobile"/>
                    </Link>
                    <button
                        data-tour="nav-menu"
                        className={`navHostBurger${mobileMenu ? ' open' : ''}`}
                        onClick={() => setMobileMenu(!mobileMenu)}
                        aria-label="Abrir menú"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </nav>
                {mobileMenu && (
                    <div className="navHostOverlay" onClick={() => setMobileMenu(false)}/>
                )}
                <div className={`navHostDrawer${mobileMenu ? ' open' : ''}`}>
                    <div className="navHostDrawerHeader">
                        <span>Menú</span>
                        <button className="navHostDrawerClose" onClick={() => setMobileMenu(false)}>✕</button>
                    </div>
                    <nav className="navHostDrawerLinks">
                        {user?.sub && <>
                            <NavLink to='/mensajes' onClick={() => setMobileMenu(false)}>Mensajes</NavLink>
                            <NavLink to='/notificaciones' onClick={() => setMobileMenu(false)}>Notificaciones{user.notifications?.client > 0 ? ` (${user.notifications.client})` : ''}</NavLink>
                            <NavLink to='/reservaciones' onClick={() => setMobileMenu(false)}>Mis Reservaciones{user.bookings ? ` (${user.bookings})` : ''}</NavLink>
                            <NavLink to='/mi-stock' onClick={() => setMobileMenu(false)}>Mi Stock</NavLink>
                            <NavLink to='/mis-productos' onClick={() => setMobileMenu(false)}>Mis Productos</NavLink>
                            <NavLink to='/perfil' onClick={() => setMobileMenu(false)}>Mi Perfil</NavLink>
                            {user?.Acepterms
                                ? <NavLink data-tour="btn-renta" to='/host' onClick={() => setMobileMenu(false)}>Modo Anfitrión</NavLink>
                                : <NavLink data-tour="btn-renta" to='/unirte' onClick={() => setMobileMenu(false)}>Renta tu almacén</NavLink>
                            }
                            <hr/>
                            <button className="drawerLogout" onClick={()=>{ setMobileMenu(false); cerrarSesion(); }}>Cerrar sesión</button>
                        </>}
                        {!user?.sub && <>
                            <button data-tour="btn-registrate" onClick={()=>{ setMobileMenu(false); setModalLogin(true) }}><b>Regístrate</b></button>
                            <button onClick={()=>{ setMobileMenu(false); setModalLogin(true) }}>Iniciar sesión</button>
                        </>}
                    </nav>
                </div>
            </>
        )
    else
    return(
        <>
            <nav className={"nav min"}>
                <nav className="navbar">
                    <Link to='/host' className="logo" tabIndex={-1}>
                        <img src={Logo}/>
                        <img src={LogoMobile} className="logoMobile"/>
                    </Link>
                    <div className="navBarHost">
                        <NavLink to='/host/reservaciones' className={location.pathname == '/host' || location.pathname == '/host/' ? 'active' : ''}>Reservaciones</NavLink>
                        <NavLink to='/host/inout' className={location.pathname.startsWith('/host/inout') ? 'active' : ''}>In / Out</NavLink>
                        <NavLink to='/host/mensajes'>Mensajes</NavLink>
                        <NavLink data-tour="nav-gestion" to='/host/gestion'>Gestión</NavLink>
                        <NavLink to='/host/dashboard'>Dashboard</NavLink>
                    </div>
                    <span className="navDerecha">
                        <Link to="/" tabIndex={-1}>Modo Cliente</Link>
                        {!tourActivo && setModalAyuda &&
                            <button className="nav-ayuda" onClick={()=> setModalAyuda(true)} title="Centro de ayuda" aria-label="Abrir centro de ayuda">?</button>
                        }
                        <span className="menu" onClick={(e)=>{
                            e.stopPropagation();
                            setMenu(!menu);
                        }}>
                            <img src={Burger} className="burger" alt="Menú"/>
                            <img src={user.url ? user.url : user.picture ? user.picture : Perfil} className={"imgPerfil"+(user.url || user.picture ? " conImg" : "")} alt="Menú Perfil" onError={alFallarFoto}/>
                            {user?.notifications?.host > 0 &&
                                <div className='numNoti'>
                                    {user.notifications?.host > 99 ? "99+" : user.notifications?.host}
                                </div>
                            }
                        </span>
                        {menu && !user.sub &&
                            <div className="menuNav" ref={menuNav}>
                                <button onClick={()=>{
                                    setModalLogin(true)
                                }}>
                                    <b>Regístrate</b></button>
                                <button onClick={()=>{
                                    setModalLogin(true)
                                }}>Iniciar sesión</button>
                            </div>
                        }
                        {menu && user.sub &&
                            <div className="menuNav" ref={menuNav}>
                                <div className="bold">
                                    <Link to="/mensajes">Mensajes</Link>
                                    <Link to="/host/notificaciones">Mis Notificaciones {(user.notifications?.host  != 0 ? `(${user.notifications?.host})` : '')}</Link>
                                    <Link to="/host/gestion/publicaciones">Mis Publicaciones {(user.posts ? `(${user.posts})` : '')}</Link>
                                    <Link to="/reservaciones">Mis Reservaciones {(user.bookings ? `(${user.bookings})` : '')}</Link>
                                    <Link to="/favoritos">Mis Favoritos{totalFavs != 0 ? " ("+totalFavs+")" : ""}</Link>
                                </div>
                                <div>
                                    <Link to="/host">Renta tu almacén</Link>
                                    <Link to="/perfil">Mi Perfil</Link>
                                    <Link to="#" onClick={eliminarDatos}>Eliminar datos (test only)</Link>
                                    <Link to="/transferencia">Simular Transferencia (test only)</Link>
                                </div>
                                <div>
                                    <Link to="/ayuda">Ayuda</Link>
                                    <button onClick={cerrarSesion}>Cerrar sesión</button>
                                </div>
                            </div>
                        }
                    </span>
                </nav>
            </nav>

            {/* Top navbar móvil — solo host, solo mobile */}
            <nav className="navHostMobile">
                <Link to='/host' className="logo" tabIndex={-1}>
                    <img src={Logo}/>
                    <img src={LogoMobile} className="logoMobile"/>
                </Link>
                <button
                    data-tour="nav-menu"
                    className={`navHostBurger${mobileMenu ? ' open' : ''}`}
                    onClick={() => setMobileMenu(!mobileMenu)}
                    aria-label="Abrir menú principal"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </nav>
            {mobileMenu && (
                <div className="navHostOverlay" onClick={() => setMobileMenu(false)}/>
            )}
            <div className={`navHostDrawer${mobileMenu ? ' open' : ''}`}>
                <div className="navHostDrawerHeader">
                    <span>Menú</span>
                    <button className="navHostDrawerClose" onClick={() => setMobileMenu(false)}>✕</button>
                </div>
                <nav className="navHostDrawerLinks">
                    <NavLink to='/host/reservaciones' onClick={() => setMobileMenu(false)} className={({isActive}) => location.pathname == '/host' || location.pathname == '/host/' ? 'active' : (isActive ? 'active' : '')}>Reservaciones</NavLink>
                    <NavLink to='/host/inout' onClick={() => setMobileMenu(false)}>In / Out</NavLink>
                    <NavLink to='/host/mensajes' onClick={() => setMobileMenu(false)}>Mensajes</NavLink>
                    {/* Gestión con flecha toggle */}
                    <button
                        data-tour="nav-gestion"
                        className={`navHostDrawerToggle${location.pathname.startsWith('/host/gestion') ? ' active' : ''}`}
                        onClick={() => setGestionOpen(o => !o)}
                    >
                        <span>Gestión</span>
                        <svg className={`drawerArrow${gestionOpen ? ' open' : ''}`} width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    {gestionOpen && (
                        <div className="navHostDrawerSubGroup">
                            <NavLink to='/host/gestion/personas' onClick={() => setMobileMenu(false)}>Personas</NavLink>
                            <NavLink data-tour="nav-almacenes" to='/host/gestion/almacenes' onClick={() => setMobileMenu(false)}>Almacenes</NavLink>
                            <NavLink data-tour="nav-publicaciones" to='/host/gestion/publicaciones' onClick={() => setMobileMenu(false)}>Publicaciones</NavLink>
                        </div>
                    )}
                    <NavLink to='/host/dashboard' onClick={() => setMobileMenu(false)}>Dashboard</NavLink>
                    <NavLink to='/host/equipo' onClick={() => setMobileMenu(false)}>Equipo de Trabajo</NavLink>
                    <hr/>
                    <Link to="/" tabIndex={-1} onClick={() => setMobileMenu(false)}>Modo Cliente</Link>
                    <hr/>
                    <button className="drawerLogout" onClick={()=>{ setMobileMenu(false); cerrarSesion(); }}>Cerrar sesión</button>
                </nav>
            </div>
        </>
    )
}

export default NavBar;